/**
 * Calculates auto placement of popover based on the most available space.
 */
import { Rect } from "./rect-utils"
import getBoundingOffsets from "./getBoundingOffsets"

type Offsets = ReturnType<typeof getBoundingOffsets>
type Edge = keyof Offsets
type OffsetEntry = [Edge, Rect]

const getAutoPosition = (popoverRect: ClientRect, offsets: Offsets) => {
  // order from largest to smallest
  const positions = (Object.entries(offsets) as OffsetEntry[]).sort(byArea)

  // select positions that the popover will fit within
  const availablePositions = availableOffsets(
    popoverRect,
    Object.entries(offsets) as OffsetEntry[]
  )
  // return the largest available position
  return availablePositions.length ? availablePositions[0][0] : positions[0][0]
}

/**
 * Sort by available space.
 */
const byArea = ([, a]: OffsetEntry, [, b]: OffsetEntry) =>
  b.height * b.width - a.height * a.width

/**
 * Selects offsets that the popover can fit within.
 */
const availableOffsets = (popoverRec: Rect, offsetEntries: OffsetEntry[]) =>
  offsetEntries.filter(
    ([, { height, width }]) =>
      height >= popoverRec.height && width >= popoverRec.width
  )

export default getAutoPosition
